export function listenIncomingMessages(callback) {
    window.addEventListener(
        "message",
        (event) => {
            const data = event.data;
            if (!data?.appSettings) return;
            const response = data.appSettings;
            const settings = JSON.parse(response.settings);
            const [component] = response.alias
                ? response.alias.split("_")
                : response.app_alias.split("_");
            const payload = {
                component,
                settings: {
                    ...settings,
                    holderWidth: data.appSettings.windowWidth || data.windowWidth,
                    holderHeight: data.appSettings.windowHeight || data.windowHeight
                },
                appData: response
            };

            callback(payload);
        },
        false
    );
}
